module.exports = __webpack_public_path__ + "static/media/arrow_out_blue.c9a25528.svg";